export default "__VITE_ASSET__GHvz2hoV__"